/* /* eslint-disable *\/ */
/**
 * // This file is auto-generated by Orval. Do not edit manually.
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { CreateMediaOutputDTO } from '../../../shared/types/api/createMediaOutputDTO';

import type { CreateMediaRestInputDTO } from '../../../shared/types/api/createMediaRestInputDTO';

import type { GetMediaOutputDTO } from '../../../shared/types/api/getMediaOutputDTO';

import type { HTTPValidationError } from '../../../shared/types/api/hTTPValidationError';

import type { SearchMediaApiV1MediaGetParams } from '../../../shared/types/api/searchMediaApiV1MediaGetParams';

import type { SearchMediaOutputDTO } from '../../../shared/types/api/searchMediaOutputDTO';

import type { UpdateMediaRestInputDTO } from '../../../shared/types/api/updateMediaRestInputDTO';

import { customInstance } from '../../../shared/api/api-client';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Create media.
 * @summary Create Media
 */
export const createMediaApiV1MediaPost = (
  createMediaRestInputDTO: CreateMediaRestInputDTO,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<CreateMediaOutputDTO>(
    {
      url: `/api/v1/media/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createMediaRestInputDTO,
      signal,
    },
    options
  );
};

export const getCreateMediaApiV1MediaPostMutationKey = () => ['createMediaApiV1MediaPost'] as const;

export const getCreateMediaApiV1MediaPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMediaApiV1MediaPost>>,
    TError,
    CreateMediaApiV1MediaPostMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createMediaApiV1MediaPost>>,
  TError,
  CreateMediaApiV1MediaPostMutationVariables,
  TContext
> => {
  const mutationKey = getCreateMediaApiV1MediaPostMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMediaApiV1MediaPost>>,
    CreateMediaApiV1MediaPostMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return createMediaApiV1MediaPost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateMediaApiV1MediaPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof createMediaApiV1MediaPost>>
>;
export type CreateMediaApiV1MediaPostMutationBody = CreateMediaRestInputDTO;
export type CreateMediaApiV1MediaPostMutationError = HTTPValidationError;
export type CreateMediaApiV1MediaPostMutationVariables = { data: CreateMediaRestInputDTO };

/**
 * @summary Create Media
 */
export const useCreateMediaApiV1MediaPost = <TError = HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createMediaApiV1MediaPost>>,
      TError,
      CreateMediaApiV1MediaPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createMediaApiV1MediaPost>>,
  TError,
  CreateMediaApiV1MediaPostMutationVariables,
  TContext
> => {
  return useMutation(getCreateMediaApiV1MediaPostMutationOptions(options), queryClient);
};
/**
 * Search media.
 * @summary Search Media
 */
export const searchMediaApiV1MediaGet = (
  params?: SearchMediaApiV1MediaGetParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<SearchMediaOutputDTO>(
    { url: `/api/v1/media/`, method: 'GET', params, signal },
    options
  );
};

export const getSearchMediaApiV1MediaGetQueryKey = (params?: SearchMediaApiV1MediaGetParams) => {
  return [`/api/v1/media/`, ...(params ? [params] : [])] as const;
};

export const getSearchMediaApiV1MediaGetQueryOptions = <
  TData = Awaited<ReturnType<typeof searchMediaApiV1MediaGet>>,
  TError = HTTPValidationError,
>(
  params?: SearchMediaApiV1MediaGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchMediaApiV1MediaGet>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSearchMediaApiV1MediaGetQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof searchMediaApiV1MediaGet>>> = ({
    signal,
  }) => searchMediaApiV1MediaGet(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchMediaApiV1MediaGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SearchMediaApiV1MediaGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchMediaApiV1MediaGet>>
>;
export type SearchMediaApiV1MediaGetQueryError = HTTPValidationError;

export function useSearchMediaApiV1MediaGet<
  TData = Awaited<ReturnType<typeof searchMediaApiV1MediaGet>>,
  TError = HTTPValidationError,
>(
  params: undefined | SearchMediaApiV1MediaGetParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchMediaApiV1MediaGet>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchMediaApiV1MediaGet>>,
          TError,
          Awaited<ReturnType<typeof searchMediaApiV1MediaGet>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSearchMediaApiV1MediaGet<
  TData = Awaited<ReturnType<typeof searchMediaApiV1MediaGet>>,
  TError = HTTPValidationError,
>(
  params?: SearchMediaApiV1MediaGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchMediaApiV1MediaGet>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchMediaApiV1MediaGet>>,
          TError,
          Awaited<ReturnType<typeof searchMediaApiV1MediaGet>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSearchMediaApiV1MediaGet<
  TData = Awaited<ReturnType<typeof searchMediaApiV1MediaGet>>,
  TError = HTTPValidationError,
>(
  params?: SearchMediaApiV1MediaGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchMediaApiV1MediaGet>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Search Media
 */

export function useSearchMediaApiV1MediaGet<
  TData = Awaited<ReturnType<typeof searchMediaApiV1MediaGet>>,
  TError = HTTPValidationError,
>(
  params?: SearchMediaApiV1MediaGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchMediaApiV1MediaGet>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getSearchMediaApiV1MediaGetQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Return media.
 * @summary Get Media
 */
export const getMediaApiV1MediaMediaUidGet = (
  mediaUid: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<GetMediaOutputDTO>(
    { url: `/api/v1/media/${mediaUid}`, method: 'GET', signal },
    options
  );
};

export const getGetMediaApiV1MediaMediaUidGetQueryKey = (mediaUid: string) => {
  return [`/api/v1/media/${mediaUid}`] as const;
};

export const getGetMediaApiV1MediaMediaUidGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getMediaApiV1MediaMediaUidGet>>,
  TError = HTTPValidationError,
>(
  mediaUid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMediaApiV1MediaMediaUidGet>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMediaApiV1MediaMediaUidGetQueryKey(mediaUid);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMediaApiV1MediaMediaUidGet>>> = ({
    signal,
  }) => getMediaApiV1MediaMediaUidGet(mediaUid, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: mediaUid !== null && mediaUid !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getMediaApiV1MediaMediaUidGet>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetMediaApiV1MediaMediaUidGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMediaApiV1MediaMediaUidGet>>
>;
export type GetMediaApiV1MediaMediaUidGetQueryError = HTTPValidationError;

export function useGetMediaApiV1MediaMediaUidGet<
  TData = Awaited<ReturnType<typeof getMediaApiV1MediaMediaUidGet>>,
  TError = HTTPValidationError,
>(
  mediaUid: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMediaApiV1MediaMediaUidGet>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMediaApiV1MediaMediaUidGet>>,
          TError,
          Awaited<ReturnType<typeof getMediaApiV1MediaMediaUidGet>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMediaApiV1MediaMediaUidGet<
  TData = Awaited<ReturnType<typeof getMediaApiV1MediaMediaUidGet>>,
  TError = HTTPValidationError,
>(
  mediaUid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMediaApiV1MediaMediaUidGet>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMediaApiV1MediaMediaUidGet>>,
          TError,
          Awaited<ReturnType<typeof getMediaApiV1MediaMediaUidGet>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMediaApiV1MediaMediaUidGet<
  TData = Awaited<ReturnType<typeof getMediaApiV1MediaMediaUidGet>>,
  TError = HTTPValidationError,
>(
  mediaUid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMediaApiV1MediaMediaUidGet>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Media
 */

export function useGetMediaApiV1MediaMediaUidGet<
  TData = Awaited<ReturnType<typeof getMediaApiV1MediaMediaUidGet>>,
  TError = HTTPValidationError,
>(
  mediaUid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMediaApiV1MediaMediaUidGet>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMediaApiV1MediaMediaUidGetQueryOptions(mediaUid, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Update media.
 * @summary Update Media
 */
export const updateMediaApiV1MediaMediaUidPatch = (
  mediaUid: string,
  updateMediaRestInputDTO: UpdateMediaRestInputDTO,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<void>(
    {
      url: `/api/v1/media/${mediaUid}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateMediaRestInputDTO,
      signal,
    },
    options
  );
};

export const getUpdateMediaApiV1MediaMediaUidPatchMutationKey = () =>
  ['updateMediaApiV1MediaMediaUidPatch'] as const;

export const getUpdateMediaApiV1MediaMediaUidPatchMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMediaApiV1MediaMediaUidPatch>>,
    TError,
    UpdateMediaApiV1MediaMediaUidPatchMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMediaApiV1MediaMediaUidPatch>>,
  TError,
  UpdateMediaApiV1MediaMediaUidPatchMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateMediaApiV1MediaMediaUidPatchMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMediaApiV1MediaMediaUidPatch>>,
    UpdateMediaApiV1MediaMediaUidPatchMutationVariables
  > = (props) => {
    const { mediaUid, data } = props ?? {};

    return updateMediaApiV1MediaMediaUidPatch(mediaUid, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMediaApiV1MediaMediaUidPatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMediaApiV1MediaMediaUidPatch>>
>;
export type UpdateMediaApiV1MediaMediaUidPatchMutationBody = UpdateMediaRestInputDTO;
export type UpdateMediaApiV1MediaMediaUidPatchMutationError = HTTPValidationError;
export type UpdateMediaApiV1MediaMediaUidPatchMutationVariables = {
  mediaUid: string;
  data: UpdateMediaRestInputDTO;
};

/**
 * @summary Update Media
 */
export const useUpdateMediaApiV1MediaMediaUidPatch = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateMediaApiV1MediaMediaUidPatch>>,
      TError,
      UpdateMediaApiV1MediaMediaUidPatchMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateMediaApiV1MediaMediaUidPatch>>,
  TError,
  UpdateMediaApiV1MediaMediaUidPatchMutationVariables,
  TContext
> => {
  return useMutation(getUpdateMediaApiV1MediaMediaUidPatchMutationOptions(options), queryClient);
};
/**
 * Delete media.
 * @summary Delete Media
 */
export const deleteMediaApiV1MediaMediaUidDelete = (
  mediaUid: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<void>(
    { url: `/api/v1/media/${mediaUid}`, method: 'DELETE', signal },
    options
  );
};

export const getDeleteMediaApiV1MediaMediaUidDeleteMutationKey = () =>
  ['deleteMediaApiV1MediaMediaUidDelete'] as const;

export const getDeleteMediaApiV1MediaMediaUidDeleteMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMediaApiV1MediaMediaUidDelete>>,
    TError,
    DeleteMediaApiV1MediaMediaUidDeleteMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMediaApiV1MediaMediaUidDelete>>,
  TError,
  DeleteMediaApiV1MediaMediaUidDeleteMutationVariables,
  TContext
> => {
  const mutationKey = getDeleteMediaApiV1MediaMediaUidDeleteMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMediaApiV1MediaMediaUidDelete>>,
    DeleteMediaApiV1MediaMediaUidDeleteMutationVariables
  > = (props) => {
    const { mediaUid } = props ?? {};

    return deleteMediaApiV1MediaMediaUidDelete(mediaUid, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMediaApiV1MediaMediaUidDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMediaApiV1MediaMediaUidDelete>>
>;

export type DeleteMediaApiV1MediaMediaUidDeleteMutationError = HTTPValidationError;
export type DeleteMediaApiV1MediaMediaUidDeleteMutationVariables = { mediaUid: string };

/**
 * @summary Delete Media
 */
export const useDeleteMediaApiV1MediaMediaUidDelete = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteMediaApiV1MediaMediaUidDelete>>,
      TError,
      DeleteMediaApiV1MediaMediaUidDeleteMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteMediaApiV1MediaMediaUidDelete>>,
  TError,
  DeleteMediaApiV1MediaMediaUidDeleteMutationVariables,
  TContext
> => {
  return useMutation(getDeleteMediaApiV1MediaMediaUidDeleteMutationOptions(options), queryClient);
};
/**
 * Request Media Review.
 * @summary Request Media Review
 */
export const requestMediaReviewApiV1MediaMediaUidRequestReviewPost = (
  mediaUid: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<unknown>(
    { url: `/api/v1/media/${mediaUid}/request-review`, method: 'POST', signal },
    options
  );
};

export const getRequestMediaReviewApiV1MediaMediaUidRequestReviewPostMutationKey = () =>
  ['requestMediaReviewApiV1MediaMediaUidRequestReviewPost'] as const;

export const getRequestMediaReviewApiV1MediaMediaUidRequestReviewPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestMediaReviewApiV1MediaMediaUidRequestReviewPost>>,
    TError,
    RequestMediaReviewApiV1MediaMediaUidRequestReviewPostMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof requestMediaReviewApiV1MediaMediaUidRequestReviewPost>>,
  TError,
  RequestMediaReviewApiV1MediaMediaUidRequestReviewPostMutationVariables,
  TContext
> => {
  const mutationKey = getRequestMediaReviewApiV1MediaMediaUidRequestReviewPostMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestMediaReviewApiV1MediaMediaUidRequestReviewPost>>,
    RequestMediaReviewApiV1MediaMediaUidRequestReviewPostMutationVariables
  > = (props) => {
    const { mediaUid } = props ?? {};

    return requestMediaReviewApiV1MediaMediaUidRequestReviewPost(mediaUid, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestMediaReviewApiV1MediaMediaUidRequestReviewPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof requestMediaReviewApiV1MediaMediaUidRequestReviewPost>>
>;

export type RequestMediaReviewApiV1MediaMediaUidRequestReviewPostMutationError =
  HTTPValidationError;
export type RequestMediaReviewApiV1MediaMediaUidRequestReviewPostMutationVariables = {
  mediaUid: string;
};

/**
 * @summary Request Media Review
 */
export const useRequestMediaReviewApiV1MediaMediaUidRequestReviewPost = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof requestMediaReviewApiV1MediaMediaUidRequestReviewPost>>,
      TError,
      RequestMediaReviewApiV1MediaMediaUidRequestReviewPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof requestMediaReviewApiV1MediaMediaUidRequestReviewPost>>,
  TError,
  RequestMediaReviewApiV1MediaMediaUidRequestReviewPostMutationVariables,
  TContext
> => {
  return useMutation(
    getRequestMediaReviewApiV1MediaMediaUidRequestReviewPostMutationOptions(options),
    queryClient
  );
};
